document.addEventListener('DOMContentLoaded', function() {
    // フィルタードロップダウンの変更時に遷移
    const filterSelects = document.querySelectorAll('[data-filter-select]');
    filterSelects.forEach(select => {
      select.addEventListener('change', function() {
        window.location.href = this.value;
      });
    });
    
    // 価格フィルター用フォーム送信処理
    const priceForm = document.querySelector('.price-filters')?.closest('form');
    if (priceForm) {
      priceForm.addEventListener('submit', function(e) {
        e.preventDefault();
        
        // 現在のURLと検索パラメータを取得
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        
        // 最小価格パラメータの設定
        const minInput = document.getElementById('price-min');
        if (minInput && minInput.value) {
          params.set('filter.v.price.gte', minInput.value);
        } else {
          params.delete('filter.v.price.gte');
        }
        
        // 最大価格パラメータの設定
        const maxInput = document.getElementById('price-max');
        if (maxInput && maxInput.value) {
          params.set('filter.v.price.lte', maxInput.value);
        } else {
          params.delete('filter.v.price.lte');
        }
        
        // その他の隠しフィールドからパラメータを取得
        const hiddenInputs = this.querySelectorAll('input[type="hidden"]');
        hiddenInputs.forEach(input => {
          if (input.name && input.value) {
            params.set(input.name, input.value);
          }
        });
        
        // 新しいURLを構築して遷移
        url.search = params.toString();
        window.location.href = url.toString();
      });
    }
  });